import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import BackgroundImage from 'gatsby-background-image'
import Typography from '~/components/atoms/Typography'
import CVButton from '~/components/atoms/CVButton'
import BathGraphFigure from '~/components/molecules/BathGraphFigure'
import Supervisor from '~/components/molecules/Supervisor'
import BGMList from '~/components/molecules/BGMList'
import NewsList from '~/components/organisms/NewsList'
import LiteratureList from '~/components/molecules/LiteratureList'
import {
	app_catch_text,
	app_category_text,
	app_contents,
	app_description_text,
	app_hero,
	app_logo,
	app_note_text,
	app_store_logo,
	app_subtitle_text,
	app_title_text,
	article,
	article_bg_icon,
	article_btn,
	article_category_text,
	article_description_text,
	article_flex,
	article_flex_reverse,
	article_image,
	article_main,
	article_note,
	article_note_text,
	article_sub,
	article_title_text,
	bath_graph_container,
	bath_graph_note,
	bg_grey,
	bg_image_border,
	bg_image_p_bottom,
	bg_image_p_top,
	bgm_list,
	concept_card,
	concept_flex,
	concept_icon,
	concept_text,
	container,
	feature_list,
	feature_list_contents,
	feature_list_text, function_list, header_container,
	list_contents,
	list_contents_end,
	list_contents_first,
	list_icon,
	list_text,
	list_title, list_x_scroll, literature_list, news_card, news_link_text, news_title,
	no_margin_top,
	pc_hide,
	rounded,
	sp_hide,
	store_logo
} from './styles'
import RECIPE_ICON from '~/images/recipe-icon.svg'
import TIMER_ICON from '~/images/timer-icon.svg'
import BOOK_ICON from '~/images/book-icon.svg'
import LIGHT_ICON from '~/images/light-icon.svg'
import MASSAGE_ICON from '~/images/massage-icon.svg'
import APP_LOGO from '~/images/app-logo.svg'
import APP_ICON from '~/images/app.svg'
import NIGHT_ICON from '~/images/night-icon.svg'
import STORE_LOGO from '~/images/store-logo.svg'
import { getAllMicrocms } from '~/utils/staticQuery'
import { summarize } from '~/utils/seo'
import NewsCard from '~/components/molecules/NewsCard'
import DotIcon from '~/components/molecules/DotIcon'
import { Container } from '~/components/layout/Container'

const App = () => {
	const articleListLength = 3
	const articles = getAllMicrocms(articleListLength)

	const {
		mock_massage,
		mock_light,
		mock_recipe,
		mock_bgm,
		mock_book,
		sbn_05,
		sbn_07,
		img_02,
		app_top,
		app_top_pc,
		...data
	} = useStaticQuery<GatsbyTypes.AppQuery>(graphql`
		query App {
			mock_massage: file(relativePath: {eq: "mock/massage.png"}) {
			    childImageSharp {
			      fluid(maxWidth: 500) {
			        ...GatsbyImageSharpFluid_withWebp
			      }
			    }
		    }
		    mock_light: file(relativePath: {eq: "mock/light.png"}) {
			    childImageSharp {
			      fluid(maxWidth: 500) {
			        ...GatsbyImageSharpFluid_withWebp
			      }
			    }
		    }
		    mock_recipe: file(relativePath: {eq: "mock/recipe.png"}) {
			    childImageSharp {
			      fluid(maxWidth: 500) {
			        ...GatsbyImageSharpFluid_withWebp
			      }
			    }
		    }
		    mock_bgm: file(relativePath: {eq: "mock/bgm_list.png"}) {
			    childImageSharp {
			      fluid(maxWidth: 500) {
			        ...GatsbyImageSharpFluid_withWebp
			      }
			    }
		    }
		    mock_book: file(relativePath: {eq: "mock/book.png"}) {
			    childImageSharp {
			      fluid(maxWidth: 500) {
			        ...GatsbyImageSharpFluid_withWebp
			      }
			    }
		    }
		    sbn_05: file(relativePath: {eq: "sbn_05.jpg"}) {
			    childImageSharp {
			      fluid(maxWidth: 500) {
			        ...GatsbyImageSharpFluid_withWebp
			      }
			    }
		    }
		    sbn_07: file(relativePath: {eq: "sbn_07.jpg"}) {
			    childImageSharp {
			      fluid(maxWidth: 500) {
			        ...GatsbyImageSharpFluid_withWebp
			      }
			    }
		    }
		    img_02: file(relativePath: {eq: "img_02.jpg"}) {
			    childImageSharp {
			      fluid(maxWidth: 500) {
			        ...GatsbyImageSharpFluid_withWebp
			      }
			    }
		    }
		    app_top: file(relativePath: {eq: "app-top.png"}) {
			    childImageSharp {
			      fluid(maxWidth: 500) {
			        ...GatsbyImageSharpFluid_withWebp
			      }
			    }
		    }
		    app_top_pc: file(relativePath: {eq: "app-top-pc.png"}) {
			    childImageSharp {
			      fluid(maxWidth: 1900) {
			        ...GatsbyImageSharpFluid_withWebp
			      }
			    }
		    }
		}
	`)
	return (
		<>
			<Container css={container}>
				<article css={[article, app_contents]}>
					<div css={app_logo}>
						<img src={APP_LOGO} alt='' />
					</div>
					<Typography variant='h5' css={app_category_text}>iOSアプリ</Typography>
					<Typography component='h1' variant='h2' color='textPrimary' css={app_catch_text}>入浴を通したリラックス体験。<br
						css={sp_hide} />いつものお風呂がスパ空間に。</Typography>
					<Typography variant='h5' css={app_subtitle_text}>入浴から入眠まで最高の寛ぎを届けるためのアプリ</Typography>
					<Typography color='textSecondary'
					            css={app_description_text}>最適な入浴時間、入眠タイミングをサポートするタイマー＆通知機能。<br css={sp_hide} />入浴剤ごとに用意された、気分を高めるための入浴レシピ。</Typography>
					<a href='https://apps.apple.com/jp/app/id1468066358' target='_blank' rel='noopener noreferrer'>
						<img src={STORE_LOGO} alt='apple store' css={app_store_logo} />
					</a>
					<Typography color='textSecondary' css={app_note_text}>※Android版リリースは現在未定です。</Typography>

					<BackgroundImage
						fluid={app_top.childImageSharp.fluid}
						css={[pc_hide, app_hero]}
					/>
					<BackgroundImage
						fluid={app_top_pc.childImageSharp.fluid}
						css={[sp_hide, app_hero]}
					/>
				</article>
			</Container>
			{/* 帯 */}
			<div css={bg_grey}>
				<Container css={container}>
					<ul css={concept_flex}>
						<li css={concept_card}>
							<figure>
								<img src={APP_ICON} css={concept_icon} />
								<figcaption>
									<Typography css={concept_text}>温泉療法専門医<br css={pc_hide} />が<br
										css={sp_hide} />監修した<br css={pc_hide} />入浴アプリ</Typography>
								</figcaption>
							</figure>
						</li>
						<li css={concept_card}>
							<figure>
								<img src={APP_LOGO} css={concept_icon} />
								<figcaption>
									<Typography css={concept_text}>入浴剤とアプリ<br css={pc_hide} />で<br
										css={sp_hide} />生まれる<br css={pc_hide} />新体験</Typography>
								</figcaption>
							</figure>
						</li>
						<li css={concept_card}>
							<figure>
								<img src={NIGHT_ICON} css={concept_icon} />
								<figcaption>
									<Typography css={concept_text}>湯上り後の<br />睡眠まで<br css={pc_hide} />サポート</Typography>
								</figcaption>
							</figure>
						</li>
					</ul>
				</Container>
			</div>
			{/* ダウンロード */}
			<Container css={container}>
				<article css={[article, article_flex]}>
					<div css={article_main}>
						<div css={[bg_grey, rounded, bg_image_border]}>
							<BackgroundImage fluid={img_02.childImageSharp.fluid} css={article_image}
							                 style={{ backgroundSize: 'cover' }} />
						</div>
					</div>
					<div css={article_sub}>
						<Typography variant='h4' color='textPrimary'
						            css={[article_title_text, app_title_text]}>医師監修のアプリが、<br css={sp_hide} />あなたをワンランク上の<br
							css={sp_hide} />おふろ体験へ。</Typography>
						<Typography css={article_description_text}>温泉療法専門医の監修した専用のアプリが、あなたを特別なスパ空間へ誘う。</Typography>
						<div css={[bg_grey, article_note]}>
							<Typography css={[article_note_text, no_margin_top]}><DotIcon />医師の監修した専用アプリと専用の入浴剤が連携</Typography>
							<Typography css={article_note_text}><DotIcon />医学的根拠のある入浴方法をアプリがサポート、最高のリラックス体験へ</Typography>
							<Typography css={article_note_text}><DotIcon />ニーズに合わせた様々な入浴レシピで、健康をサポート</Typography>
						</div>
						<a href='https://apps.apple.com/jp/app/id1468066358' target='_blank' rel='noopener noreferrer'>
							<CVButton css={article_btn}>アプリをダウンロードする</CVButton>
						</a>
					</div>
				</article>
			</Container>
			{/*	監修 */}
			<div css={bg_grey}>
				<Container css={container}>
					<article css={article}>
						<Supervisor />
					</article>
				</Container>
			</div>
			{/*	アプリの説明 */}
			<Container css={container}>
				<article css={[article, article_flex]}>
					<div css={article_sub}>
						<Typography variant='h4' color='textPrimary' css={[article_title_text, no_margin_top]}>深い眠りへ<br
							css={sp_hide} />アプリがサポート<span css={sp_hide}>。</span></Typography>
						<Typography css={article_description_text}>睡眠と入浴には、深い関わりがある。</Typography>
						<div css={[bg_grey, article_note]}>
							<Typography
								css={[article_note_text, no_margin_top]}><DotIcon />最適な入浴方法と最適な入眠時間をサポート、あなたを深い眠りへと導く</Typography>
							<Typography css={article_note_text}><DotIcon />深い眠りには「深部体温」と呼ばれる、深部の体温が鍵</Typography>
							<Typography
								css={article_note_text}><DotIcon />入浴には、「深部体温」を一時的に引き上げる効果があり、引き上げられた体温が放熱されると、人間は眠くなるという仕組みを引き出すためのサポートをアプリが行う</Typography>
						</div>
					</div>
					<div css={[article_main]}>
						<BathGraphFigure
							css={[bath_graph_container, bg_grey]}
						/>
						<Typography css={bath_graph_note}>入浴と睡眠の相関イメージ</Typography>
					</div>
				</article>

				<article css={[article, article_flex]}>
					<div css={article_main}>
						<div css={[bg_grey, rounded, bg_image_border]}>
							<BackgroundImage fluid={sbn_07.childImageSharp.fluid} css={article_image}
							                 style={{ backgroundSize: 'cover' }} />
						</div>
					</div>
					<div css={article_sub}>
						<Typography variant='body1' css={article_category_text}>機能</Typography>
						<Typography variant='h4' color='textPrimary'
						            css={article_title_text}>おふろをより一層、<br css={sp_hide} />充実させるための機能。</Typography>
						<Typography css={article_description_text}>毎日の入浴をより良い体験へと変えるための特別な機能。</Typography>
						<ul css={feature_list}>
							<li css={[feature_list_contents, list_contents_first]}>
								<img src={RECIPE_ICON} alt='' css={list_icon} />
								<Typography css={feature_list_text}>その日の気分、体調に合わせた入浴レシピを選べる</Typography>
							</li>
							<li css={feature_list_contents}>
								<img src={TIMER_ICON} alt='' css={list_icon} />
								<Typography css={feature_list_text}>入浴タイマーとヒーリング効果のある音で、自宅でスパを体験できる</Typography>
							</li>
							<li css={feature_list_contents}>
								<img src={BOOK_ICON} alt='' css={list_icon} />
								<Typography css={feature_list_text}>お風呂時間をたのしく、青空文庫の名作を聴いて楽しむ</Typography>
							</li>
							<li css={feature_list_contents}>
								<img src={LIGHT_ICON} alt='' css={list_icon} />
								<Typography css={feature_list_text}>お風呂ライト機能、視覚でも入浴を味わう</Typography>
							</li>
							<li css={[feature_list_contents, list_contents_end]}>
								<img src={MASSAGE_ICON} alt='' css={list_icon} />
								<Typography css={feature_list_text}>お風呂マッサージレシピで身体も開放する</Typography>
							</li>
						</ul>
						<a href='https://apps.apple.com/jp/app/id1468066358' target='_blank' rel='noopener noreferrer'>
							<CVButton css={article_btn}>アプリをダウンロードする</CVButton>
						</a>
					</div>
				</article>

				<article css={[article, article_flex, article_flex_reverse]}>
					<div css={article_main}>
						<div css={[bg_grey, rounded, bg_image_p_top, bg_image_border]}>
							<svg css={article_bg_icon} viewBox='0 0 16 20' xmlns='http://www.w3.org/2000/svg'>
								<path
									d='M12 2C13.1 2 14 2.9 14 4V16C14 17.1 13.1 18 12 18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H12ZM12 0H4C1.8 0 0 1.8 0 4V16C0 18.2 1.8 20 4 20H12C14.2 20 16 18.2 16 16V4C16 1.8 14.2 0 12 0ZM9.075 5.15V5.125C9.075 5.125 9.075 5.125 9.075 5.1C9.075 5.075 9.075 5.075 9.075 5.05C9.075 4.475 8.6 4 8 4C7.4 4 6.925 4.475 6.925 5.05C6.925 5.075 6.925 5.075 6.925 5.1C6.925 5.1 6.925 5.1 6.925 5.125V5.15C7 5.975 7.975 6.85 7.975 6.85C7.975 6.85 9 6 9.075 5.15ZM9.075 10.85V10.875C9.075 10.875 9.075 10.875 9.075 10.9C9.075 10.925 9.075 10.925 9.075 10.95C9.075 11.525 8.6 12 8 12C7.4 12 6.925 11.525 6.925 10.95C6.925 10.925 6.925 10.925 6.925 10.9C6.925 10.9 6.925 10.9 6.925 10.875V10.85C7 10.025 7.975 9.15 7.975 9.15C7.975 9.15 9 10 9.075 10.85C9.075 10.85 9.075 10.825 9.075 10.85ZM6 10.275L5.975 10.3C5.975 10.3 5.975 10.3 5.95 10.3C5.925 10.3 5.925 10.325 5.9 10.325C5.425 10.6 4.8 10.45 4.525 9.95C4.25 9.475 4.4 8.85 4.9 8.575C4.925 8.575 4.925 8.55 4.95 8.55C4.95 8.55 4.95 8.55 4.975 8.55C4.975 8.55 5 8.55 5 8.525C5.725 8.2 6.925 8.575 6.925 8.575C6.925 8.575 6.65 9.8 6 10.275ZM6 5.75L5.975 5.725C5.975 5.725 5.975 5.725 5.95 5.725C5.925 5.725 5.925 5.7 5.9 5.7C5.425 5.425 4.8 5.575 4.525 6.075C4.25 6.55 4.4 7.175 4.9 7.45C4.925 7.45 4.925 7.475 4.95 7.475C4.95 7.475 4.95 7.475 4.975 7.475C4.975 7.475 5 7.475 5 7.5C5.725 7.825 6.925 7.45 6.925 7.45C6.925 7.45 6.65 6.225 6 5.75ZM11.05 7.5C11.05 7.5 11.075 7.5 11.075 7.475C11.075 7.475 11.075 7.475 11.1 7.475C11.125 7.475 11.125 7.45 11.15 7.45C11.625 7.175 11.8 6.55 11.525 6.075C11.25 5.6 10.625 5.425 10.15 5.7C10.125 5.7 10.125 5.725 10.1 5.725C10.1 5.725 10.1 5.725 10.075 5.725L10.05 5.75C9.4 6.225 9.15 7.45 9.15 7.45C9.15 7.45 10.325 7.825 11.05 7.5ZM11.05 8.525C11.05 8.525 11.075 8.525 11.075 8.55C11.075 8.55 11.075 8.55 11.1 8.55C11.125 8.55 11.125 8.575 11.15 8.575C11.625 8.85 11.8 9.475 11.525 9.95C11.25 10.425 10.625 10.6 10.15 10.325C10.125 10.325 10.125 10.3 10.1 10.3L10.075 10.275C9.425 9.8 9.175 8.575 9.175 8.575C9.175 8.575 10.325 8.2 11.05 8.525Z'
									fill='#3BB7A9' />
							</svg>
							<BackgroundImage fluid={mock_recipe.childImageSharp.fluid} css={article_image}
							                 style={{ backgroundSize: 'contain' }} />
						</div>
					</div>
					<div css={article_sub}>
						<Typography variant='body1' css={article_category_text}>入浴レシピ</Typography>
						<Typography variant='h4' color='textPrimary'
						            css={[article_title_text, pc_hide]}>さまざまな入浴方法、<br
							css={sp_hide} />入浴レシピをあなたにお届け。</Typography>
						<Typography variant='h4' color='textPrimary'
						            css={[article_title_text, sp_hide]}>アプリがオススメの、<br
							css={sp_hide} />入浴プログラムをお届け。</Typography>
						<Typography css={article_description_text}>その時の体調、気分に合わせた入浴レシピ。</Typography>
						<div css={[bg_grey, article_note]}>
							<Typography
								css={[article_note_text, no_margin_top]}><DotIcon />アプリから、さまざまな入浴方法をナビゲーション付きで実践</Typography>
							<Typography css={article_note_text}><DotIcon />入浴時間・温度だけではなく、心を落ち着かせるBGMや入浴剤の提案も行う</Typography>
							<Typography css={article_note_text}><DotIcon />入浴レシピは、「基本のおすすめ」、「マッサージ」「ストーリー」などから気分に合わせて選べる</Typography>
						</div>
					</div>
				</article>

				<article css={[article, article_flex]}>
					<div css={article_main}>
						<div css={[bg_grey, rounded, bg_image_p_top, bg_image_border]}>
							<svg css={article_bg_icon} viewBox='0 0 17 20' fill='none'
							     xmlns='http://www.w3.org/2000/svg'>
								<path
									d='M8.5001 5C10.2251 5 11.8751 5.675 13.1001 6.9C15.6251 9.425 15.6251 13.55 13.1001 16.1C11.8751 17.325 10.2251 18 8.5001 18C6.7751 18 5.1251 17.325 3.9001 16.1C2.6751 14.875 2.0001 13.225 2.0001 11.5C2.0001 9.775 2.6751 8.125 3.9001 6.9C5.1251 5.675 6.7751 5 8.5001 5ZM8.5001 3C6.3251 3 4.1501 3.825 2.5001 5.5C-0.824902 8.8 -0.824902 14.2 2.5001 17.5C4.1501 19.15 6.3251 20 8.5001 20C10.6751 20 12.8501 19.175 14.5001 17.5C17.8251 14.2 17.8251 8.8 14.5001 5.5C12.8501 3.825 10.6751 3 8.5001 3ZM11.5001 0H5.5001C4.9501 0 4.5001 0.45 4.5001 1C4.5001 1.55 4.9501 2 5.5001 2H11.5001C12.0501 2 12.5001 1.55 12.5001 1C12.5001 0.45 12.0501 0 11.5001 0ZM11.6751 7.325C11.4251 7.325 11.1751 7.425 10.9751 7.625L7.8001 10.8C7.4001 11.2 7.4001 11.825 7.8001 12.225C8.0001 12.4 8.2501 12.5 8.5001 12.5C8.7501 12.5 9.0001 12.4 9.2001 12.2L12.3751 9.025C12.7751 8.625 12.7751 8 12.3751 7.6C12.2001 7.425 11.9501 7.325 11.6751 7.325Z'
									fill='#3BB7A9' />
							</svg>
							<BackgroundImage fluid={mock_bgm.childImageSharp.fluid} css={article_image}
							                 style={{ backgroundSize: 'contain' }} />
						</div>
					</div>
					<div css={article_sub}>
						<Typography variant='body1' css={article_category_text}>タイマーとBGM</Typography>
						<Typography variant='h4' color='textPrimary'
						            css={article_title_text}>あなたを癒す<br css={sp_hide} />タイマーとBGM。</Typography>
						<Typography css={article_description_text}>癒しの音が入浴時間を彩る。</Typography>
						<div css={[bg_grey, article_note]}>
							<Typography
								css={[article_note_text, no_margin_top]}><DotIcon />ピアノ音や自然の環境音を組み合わせたBGMは、日々の疲れを忘れる時間</Typography>
							<Typography css={article_note_text}><DotIcon />入浴剤とタイマーBGMを組み合わせることで、身体だけではなく、心も癒すことができる</Typography>
						</div>
						<BGMList css={bgm_list} />
					</div>
				</article>

				<article css={[article, article_flex, article_flex_reverse]}>
					<div css={article_main}>
						<div css={[bg_grey, rounded, bg_image_p_top, bg_image_border]}>
							<svg css={article_bg_icon} viewBox='0 0 16 20' fill='none'
							     xmlns='http://www.w3.org/2000/svg'>
								<path
									d='M14 2V18H2V2H14ZM16 0H0V20H16V0ZM11 4C10.45 4 10 4.45 10 5V15C10 15.55 10.45 16 11 16C11.55 16 12 15.55 12 15V5C12 4.45 11.55 4 11 4ZM8 4C7.45 4 7 4.45 7 5V9C7 9.55 7.45 10 8 10C8.55 10 9 9.55 9 9V5C9 4.45 8.55 4 8 4Z'
									fill='#3BB7A9' />
							</svg>

							<BackgroundImage fluid={mock_book.childImageSharp.fluid} css={article_image}
							                 style={{ backgroundSize: 'contain' }} />
						</div>
					</div>
					<div css={article_sub}>
						<Typography variant='body1' css={article_category_text}>文学朗読</Typography>
						<Typography variant='h4' color='textPrimary'
						            css={article_title_text}>名作文学を聴きながら、<br css={sp_hide} />入浴を楽しむ。</Typography>
						<Typography css={[article_description_text, pc_hide]}>癒しの音が入浴時間を彩る</Typography>
						<Typography css={[article_description_text, sp_hide]}>その時の気分に合った、文学作品を入浴と共に楽しむ。</Typography>
						<div css={[bg_grey, article_note]}>
							<Typography css={[article_note_text, no_margin_top]}><DotIcon />入浴剤とアプリを使い、香りと共に文学作品の世界に没入する</Typography>
							<Typography css={article_note_text}><DotIcon />その日の気分に合わせた作品を楽しみながら、一日を振り返れる</Typography>
							<Typography css={article_note_text}><DotIcon />作品ごとに再生時間が異なり、入浴タイマー としても利用できる</Typography>
						</div>
						<LiteratureList css={literature_list} />
					</div>
				</article>

				<article css={[article, article_flex]}>
					<div css={article_main}>
						<div css={[bg_grey, rounded, bg_image_p_bottom, bg_image_border]}>
							<svg css={article_bg_icon} viewBox='0 0 20 20' fill='none'
							     xmlns='http://www.w3.org/2000/svg'>
								<path
									d='M10 7C11.65 7 13 8.35 13 10C13 11.65 11.65 13 10 13C8.35 13 7 11.65 7 10C7 8.35 8.35 7 10 7ZM10 0C9.175 0 8.5 0.675 8.5 1.5C8.5 2.325 9.175 3 10 3C10.825 3 11.5 2.325 11.5 1.5C11.5 0.675 10.825 0 10 0ZM16 2.5C15.625 2.5 15.225 2.65 14.95 2.95C14.375 3.525 14.375 4.475 14.95 5.075C15.25 5.35 15.625 5.5 16 5.5C16.375 5.5 16.775 5.35 17.05 5.05C17.625 4.475 17.625 3.525 17.05 2.925C16.775 2.625 16.4 2.5 16 2.5ZM4 2.5C3.625 2.5 3.225 2.65 2.95 2.95C2.375 3.525 2.375 4.475 2.95 5.075C3.25 5.375 3.625 5.525 4 5.525C4.375 5.525 4.775 5.375 5.05 5.075C5.625 4.5 5.625 3.55 5.05 2.95C4.75 2.625 4.375 2.5 4 2.5ZM10 5C7.25 5 5 7.25 5 10C5 12.75 7.25 15 10 15C12.75 15 15 12.75 15 10C15 7.25 12.75 5 10 5ZM18.5 8.5C17.675 8.5 17 9.175 17 10C17 10.825 17.675 11.5 18.5 11.5C19.325 11.5 20 10.825 20 10C20 9.175 19.325 8.5 18.5 8.5ZM1.5 8.5C0.675 8.5 0 9.175 0 10C0 10.825 0.675 11.5 1.5 11.5C2.325 11.5 3 10.825 3 10C3 9.175 2.325 8.5 1.5 8.5ZM16 14.5C15.625 14.5 15.225 14.65 14.95 14.95C14.375 15.525 14.375 16.475 14.95 17.075C15.25 17.375 15.625 17.5 16 17.5C16.375 17.5 16.775 17.35 17.05 17.05C17.625 16.475 17.625 15.525 17.05 14.925C16.775 14.65 16.4 14.5 16 14.5ZM4 14.5C3.625 14.5 3.225 14.65 2.95 14.95C2.375 15.525 2.375 16.475 2.95 17.075C3.25 17.375 3.625 17.525 4 17.525C4.375 17.525 4.775 17.375 5.05 17.075C5.625 16.5 5.625 15.55 5.05 14.95C4.75 14.65 4.375 14.5 4 14.5ZM10 17C9.175 17 8.5 17.675 8.5 18.5C8.5 19.325 9.175 20 10 20C10.825 20 11.5 19.325 11.5 18.5C11.5 17.675 10.825 17 10 17Z'
									fill='#3BB7A9' />
							</svg>

							<BackgroundImage fluid={mock_light.childImageSharp.fluid} css={article_image}
							                 style={{ backgroundSize: 'contain' }} />
						</div>
					</div>
					<div css={article_sub}>
						<Typography variant='body1' css={article_category_text}>お風呂ライト</Typography>
						<Typography variant='h4' color='textPrimary'
						            css={article_title_text}>お風呂ライト機能に<br css={sp_hide} />癒やされる。</Typography>
						<Typography css={article_description_text}>“整い”空間を演出。お風呂ライト機能を楽しむ。</Typography>
						<div css={[bg_grey, article_note]}>
							<Typography css={[article_note_text, no_margin_top]}><DotIcon />お風呂ライト機能で視覚からリラックス</Typography>
							<Typography css={article_note_text}><DotIcon />入浴中は、お風呂ライト機能を使い、画面 の色を自由に変えることができる</Typography>
							<Typography css={article_note_text}><DotIcon />お風呂ライト機能は、普段の入浴を”整い ”空間へと変える</Typography>
						</div>
					</div>
				</article>

				<article css={[article, article_flex, article_flex_reverse]}>
					<div css={article_main}>
						<div css={[bg_grey, rounded, bg_image_p_top, bg_image_border]}>
							<svg css={article_bg_icon} viewBox='0 0 20 18' fill='none'
							     xmlns='http://www.w3.org/2000/svg'>
								<path
									d='M10 0L8 0C6.35 0 5 1.35 5 3C5 3.35 5.075 3.675 5.175 4L3 4C1.35 4 0 5.35 0 7C0 7.775 0.3 8.475 0.775 9C0.3 9.525 0 10.225 0 11C0 11.775 0.3 12.475 0.775 13C0.3 13.525 0 14.225 0 15C0 16.65 1.35 18 3 18H10L15 18C17.75 18 20 15.75 20 13L20 10C20 4.475 15.525 0 10 0ZM18 13C18 14.65 16.65 16 15 16H10L3 16C2.45 16 2 15.55 2 15C2 14.45 2.45 14 3 14L10 14C10.55 14 11 13.55 11 13C11 12.45 10.55 12 10 12L3 12C2.45 12 2 11.55 2 11C2 10.45 2.45 10 3 10L10 10C10.55 10 11 9.55 11 9C11 8.45 10.55 8 10 8L3 8C2.45 8 2 7.55 2 7C2 6.45 2.45 6 3 6H8L10 6C10.55 6 11 5.55 11 5C11 4.45 10.55 4 10 4L8 4C7.45 4 7 3.55 7 3C7 2.45 7.45 2 8 2L10 2C14.4 2 18 5.6 18 10L18 13Z'
									fill='#3BB7A9' />
							</svg>

							<BackgroundImage fluid={mock_massage.childImageSharp.fluid} css={article_image}
							                 style={{ backgroundSize: 'contain' }} />
						</div>
					</div>
					<div css={article_sub}>
						<Typography variant='body1' css={article_category_text}>マッサージ</Typography>
						<Typography variant='h4' color='textPrimary'
						            css={article_title_text}>マッサージレシピで<span css={sp_hide}>、</span><br/>身体を開放する。</Typography>
						<Typography css={[article_description_text, pc_hide]}>お風呂時間を通じて、全身の疲れをほぐす。</Typography>
						<Typography
							css={[article_description_text, sp_hide]}>お風呂時間を通じて、全身の疲れをほぐす。</Typography>
						<div css={[bg_grey, article_note]}>
							<Typography css={[article_note_text, no_margin_top]}><DotIcon />入浴とマッサージを組み合わせた専用のプログラム</Typography>
							<Typography css={article_note_text}><DotIcon />音声ガイダンスに従いながら、誰でも簡単に身体を使ってセルフケア</Typography>
							<Typography css={article_note_text}><DotIcon />手先のほぐしから下半身のむくみまで、自分をいたわる特別な時間</Typography>
						</div>
					</div>
				</article>
			</Container>
			{/*	機能一覧 */}
			<Container css={container}>
				<article css={[article, article_flex]}>
					<div css={article_sub}>
						<Typography variant='h4' color='textPrimary'
						            css={[article_title_text, no_margin_top]}>機能一覧</Typography>
					</div>
					<div css={article_main}>
						<ul css={function_list}>
							<li css={[list_contents, list_contents_first]}>
								<Typography color='textPrimary' css={list_title}>入浴レシピ</Typography>
								<Typography css={list_text}>
								すっと眠りにつくレシピ<br />
									自律神経を整える交互浴レシピ<br />
									内から発汗する分割浴レシピ<br />
									20分間の微温浴レシピ<br />
									*医師監修メニューは上記4つとなります。
								</Typography>
							</li>
							<li css={list_contents}>
								<Typography color='textPrimary' css={list_title}>タイマーとBGM</Typography>
								<Typography css={list_text}>
									約15種類の環境音<br />
									8種類のピアノ演奏<br />
									環境音とピアノ演奏を組み合わせたMIX
								</Typography>
							</li>
							<li css={list_contents}>
								<Typography color='textPrimary' css={list_title}>お風呂ライト</Typography>
								<Typography css={list_text}>
									自分好みの色相と明るさにカスタマイズ<br />
									モニターを制限してデジタルデトックス
								</Typography>
							</li>
							<li css={list_contents}>
								<Typography color='textPrimary' css={list_title}>文学朗読</Typography>
								<Typography css={list_text}>
									梶井基次郎「檸檬」<br />
									芥川龍之介「蜜柑」<br />
									芥川龍之介「蜘蛛の糸」
								</Typography>
							</li>
							<li css={[list_contents, list_contents_end]}>
								<Typography color='textPrimary' css={list_title}>マッサージ</Typography>
								<Typography css={list_text}>
									手先と首から緊張を解くストレッチ<br />
									下半身のむくみを取るマッサージ
								</Typography>
							</li>
						</ul>
					</div>
				</article>
			</Container>
			{/*	ダウンロード */}
			<div css={bg_grey}>
				<Container css={container}>
					<article css={[article, app_contents]}>
						<Typography color='textPrimary' variant='h2'>無料で今すぐ<br css={pc_hide} />ダウンロード</Typography>
						<a href='https://apps.apple.com/jp/app/id1468066358' target='_blank' rel='noopener noreferrer'>
							<img src={STORE_LOGO} alt='apple store' css={store_logo} />
						</a>
						<Typography color='textSecondary' css={app_note_text}>※Android版リリースは現在未定です。</Typography>
					</article>
				</Container>
			</div>
			{/*	ニュース */}
			<NewsList />
		</>
	)
}

export default App
